<template>
  <section>
    <div class="px-4 sm:px-6 lg:px-8 mt-4" v-show="!showList">
      <div class="relative mb-4 md:space-x-6 z-10 flex flex-col md:flex-row" v-if="promotion_code !== ''">
        <div class="bg-gray-50 md:space-x-2 flex flex-row p-4 items-center cursor-pointer w-full md:w-1/5" @click="$parent.menu = 'rebate_user'">
          <div class="svg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
              <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
            </svg>
          </div>
          <div>
            <div class="text-xs font-medium text-gray-900">推广用户数</div>
            <div class="text-sm text-blue-800 dark:bg-blue-900 dark:text-blue-300">
              {{parseInt(promotion.UserCount) || 0}}
            </div>
          </div>
        </div>
        <div class="bg-gray-50 md:space-x-2 flex flex-row p-4 items-center cursor-pointer w-full md:w-1/5" @click="$parent.menu = 'rebate_list'">
          <div class="svg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <div>
            <div class="text-xs font-medium text-gray-900">推广订单总金额</div>
            <div class="text-sm text-blue-800 dark:bg-blue-900 dark:text-blue-300">
              {{parseInt(promotion.TotalOrderAmount) || 0}}
            </div>
          </div>
        </div>
        <div class="bg-gray-50 md:space-x-2 flex flex-row p-4 items-center cursor-pointer w-full md:w-1/5">
          <div class="svg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <div>
            <div class="text-xs font-medium text-gray-900">推广总收入</div>
            <div class="text-sm text-gray-500">
              {{parseInt(promotion.TotalRebateAmount) || 0}}
            </div>
          </div>
        </div>
        <div class="bg-gray-50 md:space-x-2 flex flex-row p-4 items-center cursor-pointer w-full md:w-1/5">
          <div class="svg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <div>
            <div class="text-xs font-medium text-gray-900">当月推广总收入</div>
            <div class="text-sm text-gray-500">
              {{parseInt(promotion.MonthRebateAmount) || 0}}
            </div>
          </div>
        </div>
        <div class="bg-gray-50 md:space-x-2 flex flex-row p-4 items-center cursor-pointer w-full md:w-1/5">
          <div class="svg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <div>
            <div class="text-xs font-medium text-gray-900">可提现金额</div>
            <div class="text-sm text-gray-500">
              {{parseInt(promotion.WithdrawalAmount) || 0}}
            </div>
          </div>
        </div>
      </div>
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">推广等级</th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">推广类型</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">加盟费</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">一级返点</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">二级返点</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in PromotionTableData" :key="item.Id" :class="{'bg-gray-200': item.Id === real_promotion_group_id}">
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Name}}</td>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{ item.Type ? '分销商' : '个人' }}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.LimitAmount ? `￥${item.LimitAmount}` : 0}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.RebateRatio}}%</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.RebateRatioTwo}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="promotion_code === ''" class="text-sm mt-4">您还未申请推广邀请码，<span class="text-sm text-blue-800 dark:bg-blue-900 dark:text-blue-300 cursor-pointer" @click="$parent.menu = 'extend'">点击前往</span></div>
      <template v-else>
        <div class="text-sm mt-4">您当前的推广等级为 <span class="text-sm text-blue-800">{{userPromotion}}</span></div>
        <div class="text-sm mt-4">积分/现金返现推广链接
          <p class="underline underline-offset-1 inline-block text-indigo-600">https://www.huoyuyan.com/?aff={{user.promotion_code}}</p>
          <a href="javascript:;" @click="copy('通过邀请码注册送双倍积分 https://www.huoyuyan.com/?aff='+user.promotion_code)" title="复制链接" class="inline-block align-middle" style="margin-left: 10px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-500">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
            </svg>
          </a>
        </div>
      </template>
    </div>
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
  </section>
</template>

<script>
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, applyCode, getDetail, pageListPromotion, pagePromotion } from '../api/Extend'
import { debounce } from 'lodash'
export default {
  name: 'ExtendList',
  components: { Alert, Notify },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      showList: false,
      promotion_code: '',
      promotion: {
        UserCount: 0,
        TotalOrderAmount: 0,
        TotalRebateAmount: 0,
        MonthRebateAmount: 0,
        WithdrawalAmount: 0
      },
      query: {
        PageIndex: 1,
        PageSize: 20,
        Keyword: ''
        // Sort: 'Status'
        // Status: 1
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      relationsData: {
        main: { name: '' },
        logics: [],
        components: [],
        complexs: []
      },
      PromotionTableData: [],
      row: {},
      statusMap: {
        '1': {
          class: 'text-green-600',
          text: '进行中'
        },
        '0': {
          class: 'text-gray-500',
          text: '未开始'
        },
        '-1': {
          class: 'text-red-600',
          text: '已结束'
        },
        '-2': {
          class: 'text-red-600',
          text: '已过期'
        }
      },
      real_promotion_group_id: 0,
      userPromotion: '',
      user: null
    }
  },
  mounted () {
    this.getPromotionList()
    this.getPagePromotion()
    const userString = localStorage.getItem('hyy_www_user')
    if (userString) {
      const user = JSON.parse(userString)
      if (user && user.promotion_code) this.promotion_code = user.promotion_code
      if (user && user.real_promotion_group_id) this.real_promotion_group_id = user.real_promotion_group_id
      this.user = user
    }
    this.showList = false
  },
  methods: {
    getPagePromotion () {
      pagePromotion().then(res => {
        const data = res.data
        this.promotion.UserCount = data.UserCount
        this.promotion.TotalOrderAmount = data.TotalOrderAmount
        this.promotion.TotalRebateAmount = data.TotalRebateAmount
        this.promotion.MonthRebateAmount = data.MonthRebateAmount
        this.promotion.WithdrawalAmount = data.WithdrawalAmount
      })
    },
    getPromotionList () {
      pageListPromotion().then(res => {
        this.PromotionTableData = res.data.data.list.map(i => {
          if (i.Id === this.real_promotion_group_id) {
            this.userPromotion = i.Name
          }
          i.RebateRatio = i.RebateRatio * 100
          i.RebateRatioTwo = i.RebateRatioTwo * 100
          return i
        })
      })
    },
    copy (text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '专属推广邀请码已复制到剪切板', desc: '' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '专属推广邀请码已复制到剪切板', desc: '' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
          }
        )
      }
    },
    applyCode () {
      applyCode().then(res => {
        this.promotion_code = res.data.data
      }).catch((err) => {
        console.log(err)
      })
    },
    view (row) {
      getDetail(row.Key).then(res => {
        this.versionDialog = true
        this.row = res.data.data
      }).catch((err) => {
        console.log(err)
      })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
